import React from "react";
import PageHero from "@/components/PageHero";
import { Container, GoldButton } from "@/components/shared";

const stops = [
  { title: "St Botolph's, the Stump", body: "Climb the tower for the view across the Wash, if the steps are open. The church itself is vast and light — the heart of the mother town." },
  { title: "The Market Place", body: "Wednesday and Saturday markets fill the square. The Guildhall nearby held would-be emigrants in the 1600s and now tells the town's story." },
  { title: "The Haven", body: "Walk down to the working river where the boats still tie up. This is the water the town has always steered by." },
];

const MASS = "https://images.unsplash.com/photo-1717174704421-0ce3dc8a7225?crop=entropy&cs=srgb&fm=jpg&q=85&w=940";
const LINC = "https://images.pexels.com/photos/8755712/pexels-photo-8755712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function VisitLincolnshire() {
  return (
    <div>
      <PageHero
        kicker="Visit · The mother town"
        title="Two days in Boston, Lincolnshire"
        intro="A quiet Fenland town best taken on foot. Steer by the Stump and let the market and the Haven fill the rest."
      >
        <GoldButton as="link" to="/visit/itineraries/stump-to-common">See the full crossing route →</GoldButton>
      </PageHero>

      <section className="py-16 sm:py-24">
        <Container>
          <img src={LINC} alt="Boston, Lincolnshire" className="w-full h-[360px] object-cover border border-[#D6D3CB] mb-12" />
          <div className="max-w-3xl space-y-8">
            {stops.map((s, i) => (
              <div key={i} className="flex gap-6">
                <span className="font-serif text-3xl text-[#CDA434] w-10 shrink-0">{i + 1}</span>
                <div className="pb-8 border-b border-[#D6D3CB] flex-1">
                  <h3 className="font-serif text-xl text-[#1E1E2F] mb-2">{s.title}</h3>
                  <p className="font-sans text-base text-[#1B2430] leading-relaxed">{s.body}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
